import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/** Read / clear a record id from the URL query (e.g. ?id= for command-palette deep links). */
export function useQueryRecordId(param = "id"): {
  recordId: string | null;
  clearRecordId: () => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const recordId = searchParams.get(param);

  const clearRecordId = useCallback(() => {
    if (!searchParams.has(param)) return;
    const next = new URLSearchParams(searchParams);
    next.delete(param);
    setSearchParams(next, { replace: true });
  }, [param, searchParams, setSearchParams]);

  return { recordId, clearRecordId };
}
